import * as L from "leaflet";
import "leaflet.markercluster";
import "leaflet/dist/leaflet.css";
import { useEffect, useRef, useMemo, useState, useMap } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  LayersControl,
  MapContainer,
  TileLayer,
  GeoJSON,
  Marker,
} from "react-leaflet";
import { set } from "react-hook-form";
import MarkerClusterGroup from "react-leaflet-cluster";
import { Spinner } from "react-bootstrap";

const myIcon = L.icon({
  iconUrl: require("./marker4.jpg"),
  iconSize: [24, 35],
  iconAnchor: [12, 35],
  popupAnchor: [0, -35],
});


const ProjectMap = ({
  showGeojson,
  projectExist,
  type,
  data,
  season,
  setSelectedAlias,
  selectedAlias,
}) => {
  const navigate = useNavigate();
  const [loadingg, setLoading] = useState(false);
  const [loadingTIFF, setLoadingTIFF] = useState(false);
  const isKarnalDistrict = projectExist?.districts?.some(
    (d) => d.label.toLowerCase() === "karnal"
  );

  const indiceOptions = {
    MSI: [
      { label: "NDVI", value: "NDVI" },
      { label: "NDMI", value: "NDMI" },
      { label: "NDRE", value: "NDRE" },
      { label: "NDWI", value: "NDWI" },
      { label: "CIG", value: "CIG" },
      { label: "CIRedEdge", value: "CIRedEdge" },
    ],
    SAR: [{ label: "RVI", value: "RVI" }],
    Weather: [
      { label: "Min Temperature", value: "Temperature_Air_2m_Min_24h" },
      { label: "Max Temperature", value: "Temperature_Air_2m_Max_24h" },
      { label: "Precipitation", value: "Precipitation_Flux" },
      { label: "Wind Speed", value: "Wind_Speed_10m_Mean" },
      { label: "Relative Humidity", value: "Relative_Humidity_2m_06h" },
      { label: "Solar Radiation", value: "Solar_Radiation_Flux" },
    ],
  };

  const [bounds, setBounds] = useState(undefined);
  const [adminBoundaries, setAdminBoundaries] = useState({
    geoJSON: undefined,
    key: Date.now().toString(),
  });

  const [farmerPlots, setFarmerPlots] = useState({
    markers: [],
    geoJSON: undefined,
    key: Date.now().toString(),
  });

  const [analyticsData, setAnalyticsData] = useState({
    label: "",
    URL: "",
  });

  const fetchAdminBoundaries = async () => {
    const stateBoundaries = [];
    const districtBoundaries = [];
        const OtherRegionBoundaries = [];
    // console.log("projectExist?.region_url",projectExist?.region_url)

    const hasDistricts = projectExist?.districts?.length > 0;
    if (isKarnalDistrict) {
      const res = await axios.get(
        `https://lc-research-projects.s3.ap-south-1.amazonaws.com/nabard-karnal/karnal_sub_districts.geojson`
      );
      districtBoundaries.push(...res.data.features);
    }

    if (!hasDistricts && projectExist?.states?.length > 0) {
      for (const state of projectExist.states) {
        const res = await axios.get(
          `https://pixstack.leadsnextech.com/get_states_geojson?state_code=${state.value}`
        );
        stateBoundaries.push(...res.data.features);
      }
    } else if (hasDistricts) {
      for (const dist of projectExist.districts) {
        const res = await axios.get(
          `https://pixstack.leadsnextech.com/get_districts_geojson?state_code=${projectExist?.states?.[0].value}&district_code=${dist.value}`
        );
        districtBoundaries.push(...res.data.features);
      }
    }
     else if (projectExist?.region_url) {
        const res = await axios.get(
          projectExist?.region_url
        );
        OtherRegionBoundaries.push(...res.data.features);
      }
    
  
    return [...stateBoundaries, ...districtBoundaries,...OtherRegionBoundaries];
      // return hasDistricts ? districtBoundaries : stateBoundaries;

  };

  const fetchAnalyticsData = async (tiffURL, colormap = "rdylgn") => {
    try {
      const BaseURL = "https://z0c3v6ezdg.execute-api.ap-south-1.amazonaws.com";
      const statsResp = await fetch(`${BaseURL}/cog/statistics?url=${tiffURL}`);
      const stats = await statsResp.json();

      const tileResp = await fetch(
        `${BaseURL}/cog/tilejson.json?url=${tiffURL}&rescale=${stats.b1.min},${stats.b1.max}&colormap_name=${colormap}`
      );
      const tileData = await tileResp.json();
      const tileLayerURL = tileData.tiles[0];
      return tileLayerURL;
    } catch (error) {
      console.error("Error loading TIFF layer:", error);
    }
  };

  const mapWrapperRef = useRef(null);

  useEffect(() => {
        const showCustomBounds=projectExist?.showCustomBounds;

    const uploadedBounds=projectExist?.customBoundsInput;
    // console.log("uploadedBounds",uploadedBounds)

    fetchAdminBoundaries().then((data) => {
      const featureCollection = {
        type: "FeatureCollection",
        features: data,
      };
      setAdminBoundaries({
        geoJSON: featureCollection,
        key: Date.now().toString(),
      });
       if (uploadedBounds && showCustomBounds) {
      try {
        const parsedBounds = JSON.parse(uploadedBounds);

        if (Array.isArray(parsedBounds)) {
          const bounds = L.latLngBounds(parsedBounds);
          setBounds(bounds);
          return;
        }

        if (parsedBounds?.type && parsedBounds?.geometry) {
          const layer = L.geoJSON(parsedBounds);
          const bounds = layer.getBounds();
          setBounds(bounds);
          return; 
        }

        console.warn("⚠️ Invalid customBoundsInput format, using default boundaries.");
      } catch (err) {
        console.error("❌ Failed to parse customBoundsInput:", err);
      }
    }

      if (data.length > 0) {

        const bounds = L.geoJSON(featureCollection).getBounds();
        setBounds(bounds);
      } else {
        console.warn("No features found, skipping bounds calculation.");
      }
    });
  }, []);

  useEffect(() => {
    if (!showGeojson?.features) return;

    setFarmerPlots({ geoJSON: showGeojson, key: Date.now().toString() });
  }, [showGeojson]);
  const getColor = (ACS) => {
    if (ACS === null || ACS === undefined) return "blue";
    if (ACS < 50) return "red";
    if (ACS >= 50 && ACS <= 60) return "yellow";
    return "green";
  };

  useEffect(() => {
    if (!type || !data?.data) {
      setAnalyticsData({ label: "", URL: "" });
      return;
    }

    let selectedCategory = null;
    let matchedOption = null;

    Object.entries(indiceOptions).forEach(([category, options]) => {
      const found = options.find((opt) => opt.label === type);
      if (found) {
        selectedCategory = category;
        matchedOption = found;
      }
    });

    if (!matchedOption || !selectedCategory) return;

    const valueKey = matchedOption.value;
    // const label = matchedOption.label;
    const label = selectedAlias;
    const tiffURL =
      data.data[selectedCategory]?.[valueKey]?.MEAN?.[
        `${valueKey}_MEAN_combined`
      ] || "";

    if (!tiffURL) {
      console.warn("TIFF URL not found for:", valueKey);
      return;
    }

    fetchAnalyticsData(tiffURL).then((URL) => {
      setAnalyticsData({ URL, label });
    });
  }, [type, data, season]);

  const ReactLegend = () => {
    const grades = ["High", "Moderate", "Low"];
    const colors = ["green", "yellow", "red"];

    return (
      <div className="custom-legend-project">
        <h6 style={{ marginBottom: "10px" }}>Legend</h6>
        {grades.map((grade, i) => (
          <div className="legend-item" key={i}>
            <div
              className="legend-color"
              style={{ backgroundColor: colors[i] }}
            ></div>
            <span>{grade}</span>
          </div>
        ))}
      </div>
    );
  };

  var myIconTest = L.icon({
    iconUrl: "my-icon-url",
    iconSize: [32, 37],
    iconAnchor: [16, 37],
    popupAnchor: [0, -28],
  });

  // console.log("adminBoundaries", adminBoundaries);
  return (
    <div style={{ position: "relative", height: "100%", width: "100%" }}>
      <MapContainer
        center={bounds ? undefined : [22, 80]}
        zoom={bounds ? undefined : 5}
        bounds={bounds}
        key={JSON.stringify(bounds, analyticsData)}
        style={{ height: "100%", width: "100%" }}
        ref={mapWrapperRef}
      >
        <LayersControl collapsed={true}>
          <LayersControl.BaseLayer name="Satellite">
            <TileLayer url="https://mt0.google.com/vt/lyrs=s&hl=en&x={x}&y={y}&z={z}" />
          </LayersControl.BaseLayer>
          <LayersControl.BaseLayer name="Satellite With Labels" checked>
            <TileLayer url="https://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}" />
          </LayersControl.BaseLayer>
          <LayersControl.BaseLayer name="Streets">
            <TileLayer url="https://mt0.google.com/vt/lyrs=m&hl=en&x={x}&y={y}&z={z}" />
          </LayersControl.BaseLayer>

          {adminBoundaries.geoJSON && (
            <LayersControl.Overlay name="Admin Boundaries" checked>
              <GeoJSON
                key={adminBoundaries.key}
                data={adminBoundaries.geoJSON}
                style={{
                  fillOpacity: 0,
                  color: "yellow",
                }}
              />
            </LayersControl.Overlay>
          )}

          <LayersControl.Overlay key={farmerPlots.key} name="Plots" checked>
            <GeoJSON
              markersInheritOptions
              key={farmerPlots?.key}
              data={farmerPlots?.geoJSON}
              style={(feature) => ({
                color: getColor(feature?.properties?.ACS ?? null),
                weight: 2,
                fillOpacity: 0.5,
              })}
              onEachFeature={(feature, layer) => {
                const Wrapperdiv = document.createElement("div");
                Wrapperdiv.className = "farmer-info-wrapper";

                Wrapperdiv.innerHTML = `<div className="farmerName"> 
                  <div>
                    <b >Farmer Name </b>: ${feature.properties.farmer_name}
                   </div><br/>
                     <div>
                 <b> Mobile Number  </b>:<span> ${
                   feature.properties.phone_number
                 }</span>
                  </div><br/>
  
                   <div>
                 <b> State  </b>: ${feature.properties.state_name}
               </div><br/>
                <div>
                <b> District </b> : ${feature.properties.district_name}
                </div><br/>
               <div>
               <b> Land Mark  </b>: ${feature.properties.land_mark}
               </div><br/>
               <b class=""> Plot Id  </b>: ${feature.properties.plot_id}
               </div><br/>
                <div>
                <b> ACS  </b>: ${
                  feature.properties.ACS === null ? 0 : feature.properties.ACS
                }
                  </div>
                <div>`;
                const button = document.createElement("button");
                button.innerHTML = "View Details";
                button.style.cssText +=
                  "color:white;background-color:green;padding:7px;border:1px solid transparent;width:100%";

                button.onclick = function() {
                  navigate(
                    `/farmerDetail/onboarding/${feature.properties.farmer_id}`
                  );
                };

                Wrapperdiv.appendChild(button);

                return layer.bindPopup(Wrapperdiv);
              }}
            />
          </LayersControl.Overlay>

          {projectExist?.analytics?.crop_mask_url && (
            <LayersControl.Overlay name="Crop Mask" checked>
              <TileLayer
                url={`https://z0c3v6ezdg.execute-api.ap-south-1.amazonaws.com/cog/tiles/WebMercatorQuad/{z}/{x}/{y}@1x?url=${projectExist?.analytics?.crop_mask_url}&colormap=%7B%221%22%3A+%22%2338761D%22%2C+%222%22%3A+%22%23B7E1CD%22%7D`}
                // ?projectExist?.analytics?.crop_mask:"https://z0c3v6ezdg.execute-api.ap-south-1.amazonaws.com/cog/tiles/WebMercatorQuad/{z}/{x}/{y}@1x?url=https://lc-research-projects.s3.ap-south-1.amazonaws.com/nabard-karnal/KARNAL_CROP_MASK_V1.tif&colormap=%7B%221%22%3A+%22%2338761D%22%2C+%222%22%3A+%22%23B7E1CD%22%7D"}
                tms={false}
                zIndex={400}
              />
            </LayersControl.Overlay>
          )}

          {analyticsData.URL && (
            <LayersControl.Overlay
              key={analyticsData.label}
              name={analyticsData.label}
              checked
            >
              <TileLayer url={analyticsData.URL} />
            </LayersControl.Overlay>
          )}
        </LayersControl>
        {projectExist?.showLegends && <ReactLegend />}
      </MapContainer>
    </div>
  );
};

export default ProjectMap;
